export default "__VITE_ASSET__CI9lx0Jk__"